import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-6 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80">
            Privatlivspolitik
          </h1>
          
          <div className="prose prose-lg mx-auto text-left">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Dataansvarlig</h2>
              <p>
                Abonemt er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig. Vi sikrer, at dine personoplysninger behandles i overensstemmelse med databeskyttelseslovgivningen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. Formål med behandling af dine personoplysninger</h2>
              <p>
                Vi behandler dine personoplysninger til følgende formål:
              </p>
              <ul className="list-disc ml-6 mt-2">
                <li>At give dig den bedst mulige oplevelse på vores hjemmeside</li>
                <li>At kunne levere de services du har efterspurgt</li>
                <li>At kunne kontakte dig vedrørende relevante opdateringer og tilbud, hvis du har givet samtykke hertil</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Kategorier af personoplysninger</h2>
              <p>
                Vi behandler følgende kategorier af personoplysninger om dig:
              </p>
              <ul className="list-disc ml-6 mt-2">
                <li>Almindelige personoplysninger (fx navn og e-mailadresse)</li>
                <li>IP-adresse og browserinformation</li>
                <li>Præferencer og interesser baseret på din brug af hjemmesiden</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Dine rettigheder</h2>
              <p>
                Du har følgende rettigheder efter databeskyttelsesforordningen:
              </p>
              <ul className="list-disc ml-6 mt-2">
                <li>Ret til at se oplysninger (indsigtsret)</li>
                <li>Ret til berigtigelse</li>
                <li>Ret til sletning</li>
                <li>Ret til begrænsning af behandling</li>
                <li>Ret til dataportabilitet</li>
                <li>Ret til indsigelse</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Kontakt</h2>
              <p>
                Hvis du har spørgsmål til vores behandling af dine personoplysninger eller ønsker at gøre brug af dine rettigheder, er du velkommen til at kontakte os via vores kontaktformular.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
